import i18n from "../../../i18n";

enum RswState {
  Unknown = "Unknown",
  InitSystem = "InitSystem",
  Ready = "Ready",
  Idle = "Idle",
  Scheduled = "Scheduled",
  Navigate = "Navigate",
  Homing = "Homing",
  Standby = "Standby",
  Waiting = "Waiting",
  Restart = "Restart",
  Updating = "Updating",
  InitSystemSimulation = "InitSystemSimulation",
  StandbySimulation = "StandbySimulation",
  RestartSimulation = "RestartSimulation",
  Commissioning = "Commissioning",
  RemoteControl = "RemoteControl",
  InitMap = "InitMap",
  FleetControlActive = "FleetControlActive",
  FleetControlStandby = "FleetControlStandby",
  ErrorBaseboard = "ErrorBaseboard",
  ErrorBatteryCellImbalance = "ErrorBatteryCellImbalance",
  ErrorCamera = "ErrorCamera",
  ErrorDatabase = "ErrorDatabase",
  ErrorDiskFull = "ErrorDiskFull",
  ErrorEmergencyStop = "ErrorEmergencyStop",
  ErrorEmergencyEvacuation = "ErrorEmergencyEvacuation",
  ErrorLidar = "ErrorLidar",
  ErrorNode = "ErrorNode",
  ErrorSystem = "ErrorSystem",
  ErrorIMU = "ErrorIMU",
  MaintenanceBatteryDeep = "MaintenanceBatteryDeep",
  MaintenanceBrushFront = "MaintenanceBrushFront",
  MaintenanceBrushRoller = "MaintenanceBrushRoller",
  MaintenanceDropped = "MaintenanceDropped",
  MaintenanceEnvironmentHazard = "MaintenanceEnvironmentHazard",
  MaintenanceFilterLifetime = "MaintenanceFilterLifetime",
  MaintenanceFilterCleaner = "MaintenanceFilterCleaner",
  MaintenanceScheduled = "MaintenanceScheduled",
  MaintenanceKidnapped = "MaintenanceKidnapped",
  MaintenanceLoadMap = "MaintenanceLoadMap",
  MaintenanceNavigation = "MaintenanceNavigation",
  MaintenanceNoStationDetectedWithCamera = "MaintenanceNoStationDetectedWithCamera",
  MaintenanceNoStationDetectedWithLidar = "MaintenanceNoStationDetectedWithLidar",
  MaintenanceNoStationDetectedWithLidarAndCamera = "MaintenanceNoStationDetectedWithLidarAndCamera",
  MaintenancePositionLost = "MaintenancePositionLost",
  MaintenanceUnknownRoom = "MaintenanceUnknownRoom",
  MaintenanceWrongRoom = "MaintenanceWrongRoom",
  MaintenanceWrongFloor = "MaintenanceWrongFloor",
  MaintenanceDirtBinFull = "MaintenanceDirtBinFull",
  MaintenanceNavigationNoStation = "MaintenanceNavigationNoStation",
  MaintenanceNavigationAllZonesFailed = "MaintenanceNavigationAllZonesFailed",
  MaintenanceNavigationNoRoom = "MaintenanceNavigationNoRoom",
  MaintenanceNavigationNoPath = "MaintenanceNavigationNoPath",
  MaintenanceNavigationNotCharging = "MaintenanceNavigationNotCharging",
  MaintenanceNavigationDemoAreaTooSmall = "MaintenanceNavigationDemoAreaTooSmall",
  MaintenanceNavigationCollision = "MaintenanceNavigationCollision",
  MaintenanceNavigationNotAllowedInFreeSpace = "MaintenanceNavigationNotAllowedInFreeSpace",
  MaintenanceNavigationGateUnresponsive = "MaintenanceNavigationGateUnresponsive",
  MaintenanceTooMuchWheelSlippage = "MaintenanceTooMuchWheelSlippage",
  MaintenanceWeeklyCleaningLimit = "MaintenanceWeeklyCleaningLimit",
}

export const getRswStateDescription = (state?: RswState | null) => {
  if (state == null) {
    return null;
  }

  if (isErrorState(state)) {
    return i18n.t(`RswState.Error`);
  } else if (isMaintenanceState(state)) {
    return i18n.t(`RswState.Maintenance`);
  } else {
    return i18n.t(`RswState.${state}`);
  }
};

export const isErrorState = (state: RswState): boolean => {
  return state.startsWith("Error");
};

export const isMaintenanceState = (state: RswState): boolean => {
  return state.startsWith("Maintenance");
};

export default RswState;
